// extracted by mini-css-extract-plugin
export default {"ant-menu-horizontal":"style_ant-menu-horizontal__ebcFA","dropdown":"style_dropdown__VpS4L","avatar":"style_avatar__LrhtU"};